export default {  
  title: 'แดชบอร์ด EMP',  
  loginPageName: 'เข้าสู่ระบบ',
  logoutTip: 'ออกจากระบบ, ท່าນต้องการបន្តหรือไม่?',  
  submitText: 'ตกลง',  
  cancelText: 'ยกเลิก',  
  search: 'กรุณาป้อนເນื้อหาที่ต้องการค้นหา',  
  menuTip: 'ไม่พົບเมนູ',  
  common: {  
    condition: 'เงื่อนໄข',  
    display: 'แสดง',  
    hide: 'ซ่อน',  
  },  
  tip: {  
    select: 'กรุณาเลือก',  
    input: 'กรุณาป้อน',  
  },  
  upload: {  
    upload: 'คลิกเพื่ออัพโหลด',  
    tip: 'ลากไฟล์มาที่นี่, หรือ',  
  },  
  date: {  
    start: 'วันที่เริ่ม',  
    end: 'วันที่สิ้นสุด',  
    t: 'วันนี้',  
    y: 'เมื่อวาน',  
    n: '7 วันล่าสุด',  
    a: 'ทั้งหมด',  
  },  
  form: {  
    printBtn: 'พิมพ์',  
    mockBtn: 'จำลอง',  
    submitBtn: 'ส่ง',  
    emptyBtn: 'ลบทั้งหมด',  
    addSub: 'เพิ่มรายการย่อย',
  },  
  crud: {  
    filter: {  
      addBtn: 'เพิ่มเงື່ອນໄข',  
      clearBtn: 'ลบข้อมูล',  
      resetBtn: 'ลบเงື່ອນໄข',  
      cancelBtn: 'ยกเลิก',  
      submitBtn: 'ตกลง',  
    },  
    column: {  
      name: 'ชື່คอลัมน์',  
      hide: 'ซ่อน',  
      fixed: ' 고정',  
      filters: 'กรอง',  
      sortable: 'สามารถเรียงลำดับ',  
      index: 'ลำดับ',  
      width: 'ความกว้าง',  
    },  
    tipStartTitle: 'ตารางนี้เลือก',  
    tipEndTitle: 'รายการ',  
    editTitle: 'แก้ไข',  
    copyTitle: 'คัดลอก',  
    addTitle: 'เพิ่ม',  
    viewTitle: 'ดู',  
    filterTitle: 'เงື່ອນໄขกรอง',  
    showTitle: 'แสดง/ซ่อนคอลัมน์',  
    menu: 'การดำเนີນการ',  
    addBtn: 'เพิ่ม',  
    show: 'แสดง',  
    hide: 'ซ่อน',  
    open: 'ขยาย',  
    shrink: 'ย่อ',  
    printBtn: 'พิมพ์',  
    excelBtn: 'ส่งออก',  
    updateBtn: 'อัพเดท',  
    cancelBtn: 'ยกเลิก',  
    searchBtn: 'ค้นหา',  
    emptyBtn: 'ลบทั้งหมด',  
    menuBtn: 'ฟังก์ชัน',  
    saveBtn: 'บันทึก',  
    viewBtn: 'ดู',  
    editBtn: 'แก้ไข',  
    copyBtn: 'คัดลອກ',  
    delBtn: 'ลบ',  
  },  
  login: {  
    loginHeader: 'เข้าสู่ระบบ',
    loginAcc: 'บัญชี',
    loginAcctx: 'กรุณากรอกชื่อบัญชี',
    loginPass: 'กรุณากรอกรหัสผ่าน',
    loginPasstx: 'กรุณากรอกรหัสผ่าน',
    loginCode: 'กรุณากรอกรหัสยืนยัน',
    loginCodetx: 'กรุณากรอกรหัสยืนยัน',
    loginButton: 'เข้าสู่ระบบ',
    loginWait: 'กำลังเข้าสู่ระบบ กรุณารอสักครู่',
    ces: 'CSE',
    emp: 'EMP',
    basicLoding: 'ระบบกำลังโหลด',
    basictxLoading: 'CSE EMP ระบบกำลังโหลด',
    title: 'ลົງနาม',  
    account: 'บัญชี',
    haveAccount: 'ยังไม่มีบัญชี?',  
    info: 'BladeX แพลตฟอร์มการพัฒนาระดับองค์กร',  
    tenantId: 'ผู้เชชเชย',  
    username: 'ชื่อผู้ໃຊ้',  
    password: 'รหัสผ่าน',  
    wechat: '微信',  
    qq: 'QQ',  
    github: 'github',  
    gitee: 'Gitee',  
    phone: 'กรุณาป้อนหมายเลขโทรศัพท์',  
    code: 'กรุณาป้อนรหัสยืนยัน',  
    submit: 'ลົງနาม',  
    register: 'สมัครสมาชิก',  
    userLogin: 'ลົງနามด้วยชื่อผู้ใช้และรหัสผ่าน',  
    phoneLogin: 'ลົງနามด้วยหมายเลขโทรศัพท์',  
    thirdLogin: 'ลົງနามด้วยบริการฝ่ายที่สาม',  
    ssoLogin: 'SSO ลົງနาม',  
    msgText: 'สົ່ງรหัสยืนยัน',  
    msgSuccess: '초ลบท ที่จะส่งรหัสอีกครั้ง',  
  },  
  navbar: {  
    info: 'ข้อมูล',
    logOut: 'ออกจากระบบ',  
    userinfo: 'ข้อมูลส่วนตัว',  
    switchDept: 'เปลี่ยนแปลงแผนก',  
    dashboard: 'หน้าหลัก',  
    lock: 'ล็อคหน້าจอ',  
    bug: 'គ្មានប្រព័ន្ធកំហុស',  
    bugs: 'ប្រព័ន្ធកំហុស',  
    screenfullF: 'เลิกใช้หน้าจอเต็ม',  
    screenfull: 'หน้าจอเต็ม',  
    language: 'ภาษา',  
    notice: 'แจ้งเตือน',  
    theme: 'ธีม',  
    color: 'เปลี่ยนสี',  
  },  
  tagsView: {  
    search: 'ค้นหา',  
    menu: 'เพิ่มเติม',  
    clearCache: 'ลบแคช',  
    closeOthers: 'ปิดອື່ນๆ',  
    closeAll: 'ปิดທັງหมด',  
  },
  mBtn: {
    addSub: 'เพิ่มรายการย่อย',
    dictConfig: 'การกำหนดค่าพจนานุกรม',
    download: 'ดาวน์โหลด',
  },
  theader: {
    measuringPoint: 'จุดวัด',
    name: 'ชื่อ',
    realTimeValue: 'ค่าเรียลไทม์',
    unit: 'หน่วย',
    updateTime: 'เวลาอัปเดต',
    createTime: 'สร้างเวลา',
    storage: 'พื้นที่เก็บข้อมูล (นาที)',
    alerts: 'เตือน',
    operate: 'ดำเนินงาน',
    project: 'โครงการ',
    area: 'พื้นที่',
    detailAddress: 'ที่อยู่โดยละเอียด',
    protocol: 'โปรโตคอล',
    correspondenceAddress: 'ที่อยู่ติดต่อ',
    dataTimeout: 'หมดเวลาข้อมูล (นาที)',
    serialNumber: 'หมายเลขซีเรียล',
    deviceId: 'รหัสอุปกรณ์',
    gatewayId: 'รหัสเกตเวย์',
    gatewayName: 'ชื่อเกตเวย์',
    serialPortAddress: 'ที่อยู่พอร์ตอนุกรม',
    modelId: 'รหัสรุ่น',
    creationTime: 'เวลาสร้าง',
    updater: 'ตัวอัพเดต',
    dataEncoding: 'การเข้ารหัสข้อมูล',
    fourShakeAttributes: 'คุณสมบัติการสั่นสี่ประการ',
    storage: 'พื้นที่เก็บข้อมูล (นาที)',
    storageClass: 'ชั้นจัดเก็บข้อมูล',
    alarmTime: 'เวลาปลุก',
    recoveryTime: 'เวลาพักฟื้น',
    alarmLevel: 'ระดับสัญญาณเตือน',
    alarmContent: 'เนื้อหาปลุก',
    reportName: 'ชื่อรายงาน',
    reportTime: 'รายงานเวลา',
    equipmentFailureRate: 'อัตราความล้มเหลวของอุปกรณ์',
    score: 'คะแนน',
    healthStatus: 'สถานะสุขภาพ',
    roleName: 'ชื่อตัวละคร',
    tenants: 'ผู้เช่าเป็นเจ้าของ',
    roleAliaes: 'นามแฝงบทบาท',
    roleSorting: 'การเรียงลำดับบทบาท',
    institutionName: 'ชื่อองค์กร',
    fullNameOfOrganization: 'ชื่อเต็มขององค์กร',
    institutionType: 'ประเภทสถาบัน',
    sorting: 'เรียงลำดับ',
    loginAccount: 'บัญชีเข้าสู่ระบบ',
    userName: 'ชื่อผู้ใช้',
    role: 'บทบาท',
    department: 'แผนก',
    userPlatform: 'แพลตฟอร์มผู้ใช้',
    potitionType: 'ประเภทตำแหน่ง',
    positionNo: 'หมายเลขตำแหน่ง',
    potitionTitle: 'ชื่องาน',
    potitionSorting: 'การเรียงลำดับตำแหน่ง',
    dictionaryNumber: 'หมายเลขพจนานุกรม',
    dictionaryName: 'ชื่อพจนานุกรม',
    dictionarySorting: 'การเรียงลำดับพจนานุกรม',
    archive: 'ผนึก',
    menuName: 'ชื่อเมนู',
    rutingAddress: 'ที่อยู่เส้นทาง',
    menuIcon: 'ไอคอนเมนู',
    menuAliases: 'นามแฝงเมนู',
    menuNo: 'หมายเลขเมนู',
    menuSorting: 'การเรียงลำดับเมนู',
    tenantId: 'รหัสผู้เช่า',
    tenantName: 'ชื่อผู้เช่า',
    contact: 'ผู้ติดต่อ',
    contactNumber: 'เบอร์ติดต่อ',
    accountLimit: 'ขีดจำกัดบัญชี',
    expirationTime: 'เวลาหมดอายุ',
    bindDomainName: 'ผูกชื่อโดเมน',
    projectArea: 'พื้นที่โครงการ',
    reportAttributes: 'คุณสมบัติการรายงานสี่ประการ',
    description: 'อธิบาย',
    caculateFactor: 'ปัจจัยการคำนวณ',
    dataInfo: 'ข้อมูลข้อมูล',
  }
};
